import React from "react";
import { Col, Row, Select, Input, message } from "antd";
import Filter from "../filter";
import MainChart from "../chart";
import { graphql } from "react-apollo";

import { CONSUMER_ORIGIN_GROUPS } from "../gql/query";

const { Option } = Select;

export class GFM extends React.Component {
  state = {
    scalePeriod: null,
    intervalInput: "",
    intervals: []
  };
  renderGraphic(m, colSpan) {
    const {
      groups,
      labelType,
      labelValues,
      initialState,
      setInitialState,
      projects,
      osGroups,
      browserGroups,
      trafficChannels,
      affiliateNetworks,
      deviceTypes,
      country,
      cities,
      region
    } = this.props;
    let { dateFrom, dateTo } = this.props;
    const { scalePeriod, intervals } = this.state;
    dateFrom = dateFrom.utcOffset(0, true);
    dateTo = dateTo.utcOffset(0, true);
    return (
      <Col style={{ minWidth: "400px" }} span={colSpan} key={m}>
        <MainChart
          intervals={intervals}
          scalePeriod={scalePeriod}
          initialState={initialState[m]}
          setInitialState={setInitialState}
          metric={m}
          dateFrom={dateFrom}
          dateTo={dateTo}
          units={[]}
          groups={groups}
          osGroups={osGroups}
          browserGroups={browserGroups}
          trafficChannels={trafficChannels}
          affiliateNetworks={affiliateNetworks}
          deviceTypes={deviceTypes}
          country={country}
          cities={cities}
          region={region}
          projects={projects}
          labelType={labelType}
          labelValues={labelValues}
        />
      </Col>
    );
  }

  _handleChangeInterval = ({ target: { value: intervalInput } }) => {
    this.setState({ intervalInput });
  };

  _validateInteravl = () => {
    const arr = this.state.intervalInput
      .trim()
      .split(" ")
      .map(num => +num);
    const isArrayInvalid =
      arr[arr.length - 1] > 100 ||
      Boolean(arr.slice(0, -1).filter((item, i) => item >= arr[i + 1]).length);
    if (isArrayInvalid) message.error("Wrong intarval format");
    else this.setState({ intervals: arr });
  };

  renderGraphics() {
    return (
      <div>
        <Row gutter={8} style={{ marginTop: "8px" }} className={"charts-row"}>
          {this.renderGraphic("leads-gfm", 24)}
        </Row>
      </div>
    );
  }

  render() {
    const {
      metric,
      dateFrom,
      dateTo,
      groups,
      labelType,
      labelValues,
      dateSelector,
      region,
      osGroups,
      browserGroups,
      trafficChannels,
      affiliateNetworks,
      deviceTypes,
      country,
      cities
    } = this.props;
    const { scalePeriod } = this.state;
    return (
      <div className="page">
        <Filter
          period={[dateFrom, dateTo]}
          onPeriodChange={this.props.onPeriodChange}
          metrics={[]}
          metric={metric}
          onMetricChange={this.props.onMetricChange}
          selected={groups}
          osGroupsSelected={osGroups}
          browserGroupsSelected={browserGroups}
          trafficChannelsSelected={trafficChannels}
          affiliateNetworksSelected={affiliateNetworks}
          deviceTypesSelected={deviceTypes}
          countrySelected={country}
          regionsSelected={region}
          citiesSelected={cities}
          onLeadGroupsChange={this.props.onLeadGroupsChange}
          onOsGroupsChange={this.props.onOsGroupsChange}
          onBrowserGroupsChange={this.props.onBrowserGroupsChange}
          onTrafficChannelsChange={this.props.onTrafficChannelsChange}
          onAffiliateNetworksChange={this.props.onAffiliateNetworksChange}
          onDeviceTypesChange={this.props.onDeviceTypesChange}
          onCountryChange={this.props.onCountryChange}
          onRegionChange={this.props.onRegionChange}
          onCitiesChange={this.props.onCitiesChange}
          onUrlLabelsChange={this.props.onUrlLabelsChange}
          labelType={labelType}
          labelValues={labelValues}
          dateSelector={dateSelector}
        />
        {!this.props.data.loading && (
          <Select
            size="large"
            style={{ flex: "auto", minWidth: "300px" }}
            placeholder="Ranges"
            onChange={scalePeriod => this.setState({ scalePeriod })}
            value={scalePeriod}
          >
            {this.props.data.consumerOriginGroups && this.props.data.consumerOriginGroups.map(
              ({ groupName, groupTitle }) => (
                <Option key={groupName}>{groupTitle}</Option>
              )
            )}
            <Option key={null}>No period</Option>
          </Select>
        )}
        <Input
          type="text"
          value={this.state.intervalInput}
          placeholder="5 10 15 20 25 30 35 40 45 50 55 65 60 70 75 80 85 90 95"
          onChange={this._handleChangeInterval}
          onPressEnter={this._validateInteravl}
          onBlur={this._validateInteravl}
        />
        {this.renderGraphics()}
      </div>
    );
  }
}

export default graphql(CONSUMER_ORIGIN_GROUPS)(GFM);



// WEBPACK FOOTER //
// ./src/components/dashboard/analytics/gfm/index.js